import { FC } from 'react';
import NcModal from 'shared/NcModal/NcModal';
import Button from 'shared/Button/Button';
import { useTranslation } from 'react-i18next';

export interface UnsavedChangesModalProps {
  isOpen: boolean;
  onStay: () => void;
  onDiscard: () => void;
}

/**
 * Modal to confirm navigation when form has unsaved changes
 * Shows "Stay on page" and "Discard changes" options
 */
const UnsavedChangesModal: FC<UnsavedChangesModalProps> = ({
  isOpen,
  onStay,
  onDiscard,
}) => {
  const { t } = useTranslation();

  return (
    <NcModal
      isOpenProp={isOpen}
      onCloseModal={onStay}
      modalTitle={t('unsavedChangesModal.title')}
      contentExtraClass="max-w-md"
      renderTrigger={() => null}
      renderContent={() => (
        <div className="space-y-6" data-unsaved-changes-modal>
          <p className="text-neutral-600 dark:text-neutral-300">
            {t('unsavedChangesModal.message')}
          </p>

          <div className="flex flex-col sm:flex-row gap-3 justify-end">
            <Button
              onClick={onStay}
              className="w-full sm:w-auto"
            >
              {t('unsavedChangesModal.stay')}
            </Button>
            <Button
              onClick={onDiscard}
              className="w-full sm:w-auto bg-red-600 hover:bg-red-700 text-white"
            >
              {t('unsavedChangesModal.discard')}
            </Button>
          </div>
        </div>
      )}
    />
  );
};

export default UnsavedChangesModal;
